import { AxiosResponse } from "axios";
import ApiConstants from "../../../../../core/constants/api_constants.tsx";
import { request } from "../../../../../core/network/axiosInstance.tsx";

export class CompanyApiService {
    private readonly companyBaseUrl: string;

    constructor() {
        this.companyBaseUrl = ApiConstants().company;
    }

    async companyExists(pin: string): Promise<AxiosResponse> {
        const response = await request({
            method: "GET",
            url: `${this.companyBaseUrl}exists/${pin}`,
            requiresToken: false,
        });
        return response;
    }
} 